var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1C2033",
    width: 52,
    height: 52,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 3C16 3 3 16 3 32C3 48 16 61 32 61C48 61 61 48 61 32C61 16 48 3 32 3ZM32 59C17.1 59 5 46.9 5 32C5 17.1 17.1 5 32 5C46.9 5 59 17.1 59 32C59 46.9 46.9 59 32 59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28.4004H28C27.4 28.4004 27 28.8004 27 29.4004V49.4004C27 50.0004 27.4 50.4004 28 50.4004H36C36.6 50.4004 37 50.0004 37 49.4004V29.4004C37 28.9004 36.6 28.4004 36 28.4004ZM35 48.4004H29V30.4004H35V48.4004Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 13.5996C29.2 13.5996 27 15.7996 27 18.5996C27 21.3996 29.2 23.5996 32 23.5996C34.8 23.5996 37 21.3996 37 18.5996C37 15.7996 34.8 13.5996 32 13.5996ZM32 21.5996C30.3 21.5996 29 20.2996 29 18.5996C29 16.8996 30.3 15.5996 32 15.5996C33.7 15.5996 35 16.8996 35 18.5996C35 20.2996 33.7 21.5996 32 21.5996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationAlt);
export default __webpack_public_path__ + "static/media/information-alt.67cafe44175f28069d5b7b5b2c81145e.svg";
export { ForwardRef as ReactComponent };